"use strict";
export function changePriceForm (price) {
  if(price !== undefined){
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  else {
    return 0;
  }
}
